import React, { memo } from 'react'

import { arrayOf, func, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function CategoryGrid({ categories, onSelectCategory }) {
  const t = useTranslation()

  return (
    <div className="image-assistant-search-tab__section">
      <span className="image-assistant-search-tab__overline cgt-overline-sm">
        {t('imageAssistantPanel.searchTab.categoriesHeading')}
      </span>
      <div className="image-assistant-search-tab__grid">
        {categories.map(category => (
          <button
            key={category.value}
            type="button"
            className="image-assistant-search-tab__card image-assistant-search-tab__card--category"
            onClick={() => onSelectCategory(category)}
          >
            <img
              className="image-assistant-search-tab__card-image"
              src={category.cover}
              alt=""
              loading="lazy"
              decoding="async"
            />
            <span className="image-assistant-search-tab__card-label cgt-caption-semibold">
              {category.name}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}

CategoryGrid.propTypes = {
  categories: arrayOf(shape({
    value: string.isRequired,
    name: string.isRequired,
    cover: string.isRequired,
  })).isRequired,
  onSelectCategory: func.isRequired,
}

export default memo(CategoryGrid)
